import React from "react";
import { Box, Collapse, ListItem, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const MobileNavigationItem = ({ 
    item, 
    expanded, 
    toggleExpanded, 
    handleNavigate, 
    location, 
    activeColor 
}) => {
    const itemBasePath = item.path.split('#')[0];
    const isParentActive = location.pathname === itemBasePath || 
                           (itemBasePath !== '/' && location.pathname.startsWith(`${itemBasePath}/`));

    if (item.subItems && item.subItems.length > 0) {
        return (
            <Box sx={{ marginBottom: 1 }}>
                {/* Parent Item */}
                <ListItem
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '12px 16px',
                        backgroundColor: isParentActive ? `${activeColor}10` : 'transparent',
                        borderRadius: 2,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            backgroundColor: `${activeColor}15`,
                            transform: 'translateX(4px)'
                        }
                    }}
                    onClick={() => toggleExpanded(item.title)}
                >
                    <Typography
                        sx={{
                            fontSize: '1.1rem',
                            fontWeight: isParentActive ? 600 : 400,
                            color: isParentActive ? activeColor : '#000000'
                        }}
                    >
                        {item.title}
                    </Typography>
                    
                    <ExpandMoreIcon
                        sx={{
                            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.3s ease',
                            color: isParentActive ? activeColor : '#666666'
                        }}
                    />
                </ListItem>

                {/* Submenu Items */}
                <Collapse in={expanded} timeout={300}>
                    <Box sx={{ paddingLeft: 2, paddingTop: 1 }}>
                        {item.subItems.map((subItem) => {
                            const sectionId = subItem.path.split('#')[1];
                            
                            return (
                                <ListItem
                                    key={subItem.title}
                                    onClick={() => handleNavigate(subItem.path, sectionId)}
                                    sx={{
                                        padding: '8px 16px',
                                        borderRadius: 1,
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                            backgroundColor: `${activeColor}08`,
                                            transform: 'translateX(4px)'
                                        }
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: '0.95rem',
                                            color: '#555555',
                                            '&:hover': {
                                                color: activeColor
                                            }
                                        }}
                                    >
                                        {subItem.title}
                                    </Typography>
                                </ListItem>
                            );
                        })}
                    </Box>
                </Collapse>
            </Box>
        );
    }

    // Simple item without submenu
    return (
        <ListItem
            onClick={() => handleNavigate(item.path)}
            sx={{
                padding: '12px 16px',
                backgroundColor: isParentActive ? `${activeColor}10` : 'transparent',
                borderRadius: 2,
                cursor: 'pointer',
                marginBottom: 1,
                transition: 'all 0.2s ease',
                '&:hover': {
                    backgroundColor: `${activeColor}15`,
                    transform: 'translateX(4px)'
                }
            }}
        >
            <Typography
                sx={{
                    fontSize: '1.1rem',
                    fontWeight: isParentActive ? 600 : 400,
                    color: isParentActive ? activeColor : '#000000'
                }}
            >
                {item.title}
            </Typography>
        </ListItem>
    );
};

export default MobileNavigationItem;
